module.exports = __webpack_public_path__ + "media/images/offers-default-5c884f83200835dcb28981a71e692887.svg";